import React, { useContext, useEffect, useState } from 'react';
import { Center, SimpleGrid } from '@mantine/core';
import EmailHistoryList from '../../Organismns/Message/EmailHistoryList';
import { WindowContext } from '../../Service/Context/WindowContext';
import { useQuery } from '../../Helpers/UrlQuery';
import { TransButtonLinkWithIcon, TransButtonPrimaryWithIcon } from '../../Atoms/Buttons';
import { ModalFlowParent } from '../../Organismns/ModalFlow/ModalFlowParent';
import Pagination from '../../Atoms/Pagination';

const EmailMasterDetail = ({
  emails,
  children,
  emailAction,
  setEmailAction,
  isLoading,
  changeEmailById,
  event,
  page,
  setPage,
  countOfPages,
}) => {
  const [selectedEmail, setSelectedEmail] = useState(undefined);
  const { windowWidth } = useContext(WindowContext);

  const query = useQuery();
  const emailId = query.get('emailId');

  const [showMessageTemplateModal, setMessageTemplateModal] = useState(!!query.get('message_template'));

  useEffect(() => {
    if (emails.length > 0) {
      if (emailId) {
        const optionalEmail = emails.find((e) => e.id === parseInt(emailId));
        if (optionalEmail) {
          setSelectedEmail(optionalEmail);
        } else {
          setSelectedEmail(emails[0]);
        }
      } else {
        setSelectedEmail(emails[0]);
      }
      // setEmailAction(undefined);
    } else {
      setSelectedEmail(undefined);
    }
  }, [emails, emailId]);

  function loopThrough(id, patch) {
    if (selectedEmail && selectedEmail.id === id) {
      setSelectedEmail(patch);
    }
    changeEmailById(id, patch);
  }

  const styles = {
    container: {
      overflowY: 'scroll',
      minWidth: 200,
      paddingTop: 10,
      borderRight: windowWidth > 800 ? 'solid 1px #e5e5e5' : 'unset',
      marginTop: windowWidth < 800 ? 0 : -10,
      marginBottom: windowWidth < 800 ? 10 : -10,
      paddingRight: 10,
    },
    noEmailSelected: {
      marginTop: 100,
      marginBottom: 100,
      fontSize: '0.875rem',
      textAlign: 'center',
    },
    masterDetail: {
      display: 'flex',
      flexDirection: windowWidth > 800 ? 'row' : 'column-reverse',
    },
    displayEmail: {
      marginLeft: windowWidth > 800 ? 5 : 0,
      flex: 1,
    },
    buttons: {
      paddingBottom: 10,
    },
  };

  return (
    <div style={styles.masterDetail}>
      <div style={styles.container}>
        <div style={styles.buttons}>
          <TransButtonPrimaryWithIcon
            id="newEmail"
            text={windowWidth > 840 ? 'actions.email.new' : undefined}
            icon="EMAIL"
            onClickHandler={() => setEmailAction('NEW')}
          />
          {window.location.pathname.includes('/events') && (
            <TransButtonLinkWithIcon
              id="loadTemplate"
              icon="BOOKMARK"
              style={{ marginLeft: 5 }}
              dataTour="from-email-template"
              className="primary-link-new"
              onClick={() => setMessageTemplateModal(true)}
              text={windowWidth > 800 ? 'email.template.load' : undefined}
            />
          )}
        </div>
        <SimpleGrid cols={1}>
          <EmailHistoryList
            emails={emails}
            email={selectedEmail}
            emailSelected={(email) => {
              if (email.id !== selectedEmail.id) {
                setEmailAction(undefined);
              }
              setSelectedEmail(email);
            }}
            idOfSelectedEmail={selectedEmail ? selectedEmail.id : undefined}
            isLoading={isLoading}
            event={event}
          />
          <Center>
            <Pagination countOfPages={countOfPages} selectPage={setPage} activePage={page} />
          </Center>
        </SimpleGrid>
      </div>
      <div style={styles.displayEmail}>
        {React.cloneElement(children[0], {
          emailId: selectedEmail ? selectedEmail.id : undefined,
          changeEmailById: loopThrough,
          emailAction,
          setEmailAction,
        })}
        {React.cloneElement(children[1], {
          email: selectedEmail,
          changeEmailById,
          emailAction,
          setEmailAction,
        })}
      </div>
      {window.location.pathname.includes('/events') && (
        <ModalFlowParent
          setEmailAction={setEmailAction}
          show={showMessageTemplateModal}
          toggle={() => {
            setMessageTemplateModal(false);
          }}
        />
      )}
    </div>
  );
};

export default EmailMasterDetail;
